module.exports = __webpack_public_path__ + "static/media/shopping-cart.642ac7e1.png";